<template>
  <div class="final-leader-board-head">
    <div class="final-title">
      {{ $t('final_leaderboard') }}
    </div>
    <div
      v-if="isAnsweredAtLeastOne"
      v-html="$t('final_answers_stat', {
        correctAnswers: correctAnswers,
        totalQuiz: totalQuiz,
        correctRate: roundedCorrectRate
      })"
      class="final-stat"
    />
    <div
      v-if="!isAnsweredAtLeastOne"
      v-html="$t('you_missed_quiz')"
      class="final-rank"
    />
    <div
      v-if="isAnsweredAtLeastOne"
      v-html="$t('final_ranking', {
        ranking: ranking
      })"
      class="final-rank"
    />
    <div
      v-if="isAnsweredAtLeastOne"
      class="section-cta"
    >
      <button @click="viewMyAnswers">
        {{ $t('view_answers') }}
      </button>
    </div>
    <div v-if="isShowAudiencePacingNextSlide" class="audience-pacing-next-action">
      <ButtonV2
        size="lg"
        @click="$emit('handleClickNextSlide')"
      >
        <span>{{ $t('nextButton') }}</span>
        <AhaSvg
          name="arrow-no-tail"
          view-box="0 0 8 14"
        />
      </ButtonV2>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ButtonV2 from '@/components/UI/Buttonv2.vue'

export default {
  components: {
    ButtonV2,
  },
  props: {
    leaderboardData: {
      type: Object,
      default: () => {},
    },
    presentationID: {
      type: Number,
      default: null,
    },
    rank: {
      type: Object,
      default: () => {},
    },
    isShowAudiencePacingNextSlide: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      myQuizAnswers: (state) => state.myQuizAnswers,
    }),
    roundedCorrectRate() {
      return Math.round((this.correctAnswers / this.totalQuiz) * 100)
    },
    currentPosition() {
      return this.rank && this.rank.ranking
    },
    ranking() {
      const totalPlayers = (this.leaderboardData
        && this.leaderboardData.audiences
        && this.leaderboardData.audiences.length
      ) || 0

      return `${this.currentPosition} / ${totalPlayers}`
    },
    totalQuiz() {
      return (this.leaderboardData && this.leaderboardData.totalQuiz) || 1
    },
    correctAnswers() {
      return (this.myQuizAnswers && this.myQuizAnswers.filter(
        (item) => {
          if (item.Slide && item.Slide.slideType === 'typeAnswer') {
            return this.isTypeAnswerCorrect(item)
          }

          return item.correct
        },
      ).length) || 0
    },
    isAnsweredAtLeastOne() {
      return this.currentPosition !== -1
    },
  },
  methods: {
    ...mapActions(['setActiveTabAction']),
    viewMyAnswers() {
      const trackingProps = {
        eventName: 'Leaderboard > View Answer',
        eventAction: 'View answers',
        eventLabel: 'Answers',
        eventCategory: 'Audience',
        presentationId: this.presentationID,
      }

      this.setActiveTabAction({ activeTab: 'answers', trackingProps })
    },
    isTypeAnswerCorrect(quizAnswer) {
      const typeAnswer = quizAnswer && quizAnswer.typeAnswer
      const otherCorrectQuiz = (quizAnswer
        && quizAnswer.Slide
        && quizAnswer.Slide.otherCorrectQuiz)
        ? JSON.parse(quizAnswer.Slide.otherCorrectQuiz)
        : []

      const acceptedAnswer = otherCorrectQuiz.some((item) => item.title === typeAnswer)

      return (quizAnswer && quizAnswer.correct) || acceptedAnswer
    },
  },
}
</script>

<style lang="scss" scoped>
.final-leader-board-head {
  margin-bottom: 24px;
}

.final-title {
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 12px;
}

.final-stat {
  margin-bottom: 8px;

  strong {
    font-weight: 700;
  }
}

.final-rank {
  margin-bottom: 8px;

  strong {
    font-weight: 700;
  }
}

.section-cta {
  text-align: center;

  button {
    display: inline-block;
    padding: 9px 40px;
    min-width: 190px;
    background-color: #fff;
    border-radius: 26px;
    border: 1px solid var(--base-50, #D1D1D1);
    cursor: pointer;
    font-weight: 700;
    transition: 0.2s all ease;

    @media screen and (min-width: 1280px) {
      &:hover {
        color: #fff;
        border-color: #F4F4F4;
        background-color: #6298EB;
      }
    }
  }
}

.audience-pacing-next-action {
  margin-top: 12px;

  button {
    padding-left: 40px;
    padding-right: 40px;
    min-width: 190px;
  }
}
</style>
